/* eslint-disable react/no-unescaped-entities */
import { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import { UiSpinner, UiStack, UiText, UiVStack, uiStyles } from '@/lib/ui';
import BaseMessageBarInfo from '@/base/MessageBar/Info';
import RegistrationDetails from './RegistrationDetails';
import { type Registration } from '@/api/registration';
import InfoBox from '@/registration/component/InfoBox';

interface ConfirmationPageProps {
  data: Registration | undefined
  isLoading: boolean
  error: any
  fetchError: any
  statusToCheck: string
  confirmationMetadata?: {
    title?: string
    message?: string
  }
}

const ConfirmationPage: FC<ConfirmationPageProps> = ({ data, isLoading, error, fetchError, statusToCheck, confirmationMetadata }) => {
  const hasError = error || fetchError;

  if (isLoading) {
    return (
      <RegisterLayout>
        <UiVStack spacing={4}>
          <UiSpinner />
          <UiText variant={'h6'}>We're completing your registration, please wait</UiText>
        </UiVStack>
      </RegisterLayout>
    );
  }

  return (
    <RegisterLayout header={<> </>}>
      <BaseTransitionSlideLeft>
        <UiStack flexGrow={1} spacing={4}>
          <UiStack>
            {hasError && <UiText variant={'h6'}>Registration failed</UiText>}
            {data?.status === statusToCheck && (
              <InfoBox title={confirmationMetadata?.title || 'Registration successful'} />
            )}
          </UiStack>
          {hasError && (
            <BaseMessageBarInfo borderRadius={uiStyles.borderRadius} bgColor={'red.100'}>
                Something went wrong, please try again later
            </BaseMessageBarInfo>)}
          {data?.status === statusToCheck && (
            <>
              <BaseMessageBarInfo borderRadius={uiStyles.borderRadius} bgColor={'green.100'}>
                  {confirmationMetadata?.message || 'We\'ve sent your registration details to your email. It might take several minutes to arrive. Please also check your spam or junk folder.'}
              </BaseMessageBarInfo>
              <RegistrationDetails registration={data} />
            </>
          )}
        </UiStack>
      </BaseTransitionSlideLeft>
      <UiStack height={96} />
    </RegisterLayout>
  );
};

export default ConfirmationPage;
